// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-b283c61e]:export {\n  green: #67c892;\n  green-light: #9ec867;\n  yellow: #edc84c;\n  orange: #e9ad6a;\n  red: #e96a6a;\n  secondaryColor: #30415d;\n  primaryColor: #5dbfe2;\n  primaryColorDark: #4886a5;\n  gray: #a1a1a1;\n}\n.change-over-time-chart[data-v-b283c61e] {\n  width: 100%;\n}\n.is-pdf[data-v-b283c61e] {\n  -webkit-transform: scale(0.9);\n          transform: scale(0.9);\n}", ""]);
// Exports
module.exports = exports;
